<template>
  <footer class="footer">
    <div class="columns">
      <div class="column">
        <ul>
          <li v-for="route in getRoutes" :key="route.id">
            <router-link :to="route.path">{{ $t(route.name) }}</router-link>
          </li>
          <!--                    <li><router-link to="/projects">{{ $t('projects') }}</router-link></li>-->
          <!--                    <li><router-link to="/contact">{{ $t('contact') }}</router-link></li>-->
        </ul>
      </div>
      <div class="column has-text-right" style="position:relative">
        <ul>
          <li>{{ this.currentYear }} &copy; Aleksi Hynönen</li>
          <li><v-locale-changer class="is-pulled-right" /></li>
          <li v-if="isTracking">
            <a href="#" @click.prevent="disableTracking">{{
              $t("tracking")
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import vLocaleChanger from "../vLocaleChanger";

export default {
  components: {
    vLocaleChanger
  },
  methods: {
    toggleNav() {
      this.isActive = !this.isActive;
    },
    disableTracking: function() {
      this.$ga.disable();
      this.isTracking = false;
      localStorage.setItem("ga-is-tracking", "false");
      alert("Google Analytics tracking disabled");
    }
  },
  computed: {
    currentYear() {
      const now = new Date();
      return now.getFullYear();
    },
    getRoutes() {
      const excluded = ["not-found", "home", "apps"];
      return this.$router.options.routes.filter(
        i => !excluded.includes(i.name)
      );
    }
  },
  created: function() {
    if (localStorage.getItem("ga-is-tracking") === "false") {
      this.$ga.disable();
    }
  },
  data() {
    if (!localStorage.getItem("ga-is-tracking")) {
      localStorage.setItem("ga-is-tracking", "true");
    }
    const isTracking = localStorage.getItem("ga-is-tracking") === "true";
    return {
      isActive: false,
      isTracking
    };
  }
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: auto;
}
</style>

<i18n>
{
    "en": {
        "projects": "Projects",
        "contact": "Contact",
        "experience": "Experience",
        "tracking": "Disable GA tracking"
    },
    "fi": {
        "projects": "Projektit",
        "contact": "Yhteystiedot",
        "experience": "Kokemus",
        "tracking": "Kytke GA pois päältä"
    }
}
</i18n>
